import Vue from 'vue';
import upperFirst from 'lodash/upperFirst';
import camelCase from 'lodash/camelCase';

// look for files in the current directory: .
// do not look in subdirectories: false
// only include "_base-" prefiexd .vue files
const requireComponent = require.context('.', false, /_base-[\w-]+\.vue$/);

requireComponent.keys().forEach(filename => {
  // get the component config
  const config = requireComponent(filename);

  // get the PascalCase version of the component name
  const name = upperFirst(
    camelCase(filename.replace(/^\.\/_/, '').replace(/\.\w+$/, ''))
  );

  // globally register the component
  Vue.component(name, config.default || config);
});
